// ANT Design
import { memo } from 'react';
import shallow from 'zustand/shallow';
import { useStore } from '../../store/store';
import { isASelectionBox } from '../../utils/boxes';
// Common
import { Dragger, DraggerPdf } from './Dragger';
import { getBoxById } from '../../store/lookups';
import SelectionBox from './SelectionBox';
import Resizer from './Resizer';
import './Utils.css';
import { viewerTypes } from '../../constants/constants';

// Sélecteur objet + shallow : seul le BoxWrapper dont isSelected/isSelectionBox change re-rend
// (shallow compare le contenu de l'objet, pas la référence — évite des centaines de re-renders dans InfinitePage).
const selector = (id) => (state) => {
  const box = getBoxById(state.boxes, state.masks, id);
  return {
    isSelected: state.selectedBoxId === id,
    isSelectionBox: isASelectionBox(box?.type),
    fromPdf: state.fromPdf,
  };
};

const BoxWrapper = memo(({ id, drawMode, columnWidth, fromViewer }) => {
  const { isSelected, isSelectionBox, fromPdf } = useStore(selector(id), shallow);

  if (isSelectionBox) {
    return <SelectionBox id={id} fromViewer={fromViewer} />;
  }

  // En PDF, aucune box n'est sélectionnée → Dragger statique sans react-dnd.
  if (fromPdf) {
    return <DraggerPdf id={id} drawMode={drawMode} fromViewer={fromViewer} isSelected={isSelected} />;
  }

  if (isSelected && fromViewer !== viewerTypes.PAGENUMBER && fromViewer !== viewerTypes.DMZ && fromViewer !== viewerTypes.PREVIEW) {
    return <Resizer id={id} drawMode={drawMode} columnWidth={columnWidth} fromViewer={fromViewer} isSelected={isSelected} />;
  } else {
    return <Dragger id={id} drawMode={drawMode} columnWidth={columnWidth} fromViewer={fromViewer} isSelected={isSelected} />;
  }
});

export default BoxWrapper;
